import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { DomainRoutingModule } from './domain-routing.module';

import { ShopsBrowserComponent } from './shops-wrapper/shops/components/shops-browser/shops-browser.component';
import { ProductsBrowserComponent } from './products/products-browser/products-browser.component';
import { ProductsDataService } from './products/services/products.data.service';
import { ShopCreateComponent } from './shops-wrapper/shops/components/shop-create/shop-create.component';
import { ShopPageComponent } from './shops-wrapper/shops/components/shop-page/shop-page.component';

import { CompetitorShopsResolver } from './shops-wrapper/shops';
import { EditableShopResolver } from './shops-wrapper/shops';

import { ProductPageComponent } from './products/product-page/product-page.component';
import {
    ProductLogicsDefaultComponent,
    ProductLogicsMainComponent,
    ProductLogicsDependentComponent,
} from './products/product-page/product-logics/product-logics.component';
import { ProductLogicsModalComponent } from './products/product-page/product-logics/product-logics-modal/product-logics-modal.component';
import { ProductPageResolver } from './products/services/product-resolver.service';

import { ReferencesDialogComponent } from '../shared/references-dialog/references-dialog.component';
import { ProductLogicsModalBrowserNewComponent } from './products/product-page/product-logics/product-logics-modal/product-logics-modal-browser-new/product-logics-modal-browser-new.component';
import { ProductLogicsModalSummaryNewComponent } from './products/product-page/product-logics/product-logics-modal/product-logics-modal-summary-new/product-logics-modal-summary-new.component';
import { PriceContractsComponent } from './products/product-page/price-contracts/price-contracts.component';
import { FeaturesBrowserComponent } from './features/features-browser/features-browser.component';
import { FeaturesCreateComponent } from './features/features-create/features-create.component';
import { FeaturesPageComponent } from './features/features-page/features-page.component';
import {FeaturesDataService} from './features/services/features.data.service';
import {FeaturesEditComponent} from 'app/domain/features/features-edit/features-edit.component';
import {StoresDataService} from 'app/domain/shops-wrapper/shops/services/stores.data.service';
import {ShopsDetailsWrapperComponent} from 'app/domain/shops-wrapper/shops-details-wrapper/shops-wrapper.component';
import {ShopFloorplanPageComponent} from 'app/domain/shops-wrapper/shops/components/shop-floorplan-page/shop-floorplan-page.component';
import { FloorplanShelvesComponent } from './shops-wrapper/shops/components/floorplan-shelves/floorplan-shelves.component';
import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import {CurrentAssortmentService} from 'app/prices/current-assortment/services/current-assortment.service';
import { SettingsComponent } from './settings/settings/settings.component';
import { ShelvesBrowserComponent } from './settings/shelves-browser/shelves-browser.component';
import { ShelfCreateComponent } from './settings/shelf-create/shelf-create.component';
import { ShelfPageComponent } from './settings/shelf-page/shelf-page.component';
import {PbiReportComponent} from 'app/components/pbi-report/pbi-report.component';
import {ReportsComponent} from 'app/domain/reports/reports/reports.component';
import {MatTabsModule} from '@angular/material/tabs';

@NgModule({
    imports: [SharedModule, DomainRoutingModule, TriStateCheckboxModule, MatTabsModule],
    declarations: [
        ShopCreateComponent,
        ProductsBrowserComponent,
        ShopsBrowserComponent,
        ProductPageComponent,
        ProductLogicsDefaultComponent,
        ProductLogicsMainComponent,
        ProductLogicsDependentComponent,
        ProductLogicsModalComponent,
        PriceContractsComponent,
        ShopPageComponent,
        ShopFloorplanPageComponent,
        ShopsDetailsWrapperComponent,
        ProductLogicsModalBrowserNewComponent,
        ProductLogicsModalSummaryNewComponent,
        FeaturesBrowserComponent,
        FeaturesCreateComponent,
        FeaturesEditComponent,
        FeaturesPageComponent,
        FloorplanShelvesComponent,
        SettingsComponent,
        ShelvesBrowserComponent,
        ShelfCreateComponent,
        ShelfPageComponent,
        ReportsComponent
    ],
    entryComponents: [
        ProductLogicsDefaultComponent,
        ProductLogicsMainComponent,
        ProductLogicsDependentComponent,
        ProductLogicsModalComponent,
        ReferencesDialogComponent
    ],
    providers: [
        ProductsDataService,
        CompetitorShopsResolver,
        EditableShopResolver,
        ProductPageResolver,
        FeaturesDataService,
        StoresDataService,
        CurrentAssortmentService
    ],
})
export class DomainModule {}
